import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import './Button.css';
import { HashLink as Link } from 'react-router-hash-link';
import scrollFunction from '../../utils/scroll';

class Button extends Component {
  render() {
    if (this.props.submit) {
      return (
        <button
          disabled={this.props.disabled}
          className={`button ${this.props.modifier ? this.props.modifier : ''}`}
          onClick={(e) => {if (this.props.onClick) {this.props.onClick(e)}}}
        >
          {this.props.text}
        </button>
      );
    }
    return (
      <Link
        scroll={scrollFunction}
        to={this.props.link}
        className={`button ${this.props.modifier ? this.props.modifier : ''}`}
        role="button"
        onClick={(e) => {if (this.props.onClick) {this.props.onClick(e)}}}
      >
        {this.props.text}
      </Link>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js